import { tuningHistoryToFirestore } from '@parallel-fluidics/shared/models/tuningHistory';
import {
  addDoc,
  collection,
  getFirestore,
} from 'firebase/firestore';

export default function createTuningHistory(tuningHistoryData) {
  const docData = tuningHistoryToFirestore(tuningHistoryData);
  return addDoc(collection(getFirestore(), 'tuningHistory'), docData);
}
